import {getEventClickValue} from "./actionTypes";

export const getCurrentEventValue = (payload) =>{
    return {
        type:getEventClickValue.GET_EVENT_VALUE,
        payload,
    }
}